import { TDisplayModeEditDirection } from '@infotech-soe/metaschema';

export const getNextCellIndex = (
  [rowIndex, columnIndex]: [number, number],
  submitDirection: TDisplayModeEditDirection
): [number, number] => {
  switch (submitDirection) {
    case 'up':
    case 'down':
      return [rowIndex + (submitDirection === 'up' ? -1 : 1), columnIndex];
    case 'left':
    case 'right':
      return [rowIndex, columnIndex + (submitDirection === 'left' ? -1 : 1)];
  }
};
